import _ from 'lodash'

import { marshalTemplate } from '@/utils/marshal'

import {
  LIST_EMAIL_TEMPLATES_STARTED,
  LIST_EMAIL_TEMPLATES_COMPLETED,
  LIST_EMAIL_TEMPLATES_FAILED,

  LIST_SMS_TEMPLATES_STARTED,
  LIST_SMS_TEMPLATES_COMPLETED,
  LIST_SMS_TEMPLATES_FAILED,

  GET_TEMPLATE_STARTED,
  GET_TEMPLATE_COMPLETED,
  GET_TEMPLATE_FAILED,

  CREATE_TEMPLATE_STARTED,
  CREATE_TEMPLATE_COMPLETED,
  CREATE_TEMPLATE_FAILED,

  RESTORE_TO_DEFAULT_TEMPLATE_STARTED,
  RESTORE_TO_DEFAULT_TEMPLATE_COMPLETED,
  RESTORE_TO_DEFAULT_TEMPLATE_FAILED,

  CLEAR_STATES
} from '@/store/types'

function getDefaultState () {
  return {
    emailTemplates: [],
    smsTemplates: [],
    template: undefined,
    languages: [],

    loading: false,
    error: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    // List email templates
    [LIST_EMAIL_TEMPLATES_STARTED] (state) {
      state.loading = true
      state.emailTemplates = []
      state.languages = []
    },
    [LIST_EMAIL_TEMPLATES_COMPLETED] (state, { templates, languages }) {
      state.loading = false
      state.emailTemplates = _.cloneDeep(templates)
      state.languages = _.cloneDeep(languages)
    },
    [LIST_EMAIL_TEMPLATES_FAILED] (state, err) {
      console.error(err)
      state.loading = false
      state.error = err
    },

    // List sms templates
    [LIST_SMS_TEMPLATES_STARTED] (state) {
      state.loading = true
      state.smsTemplates = []
      state.languages = []
    },
    [LIST_SMS_TEMPLATES_COMPLETED] (state, { templates, languages }) {
      state.loading = false
      state.smsTemplates = _.cloneDeep(templates)
      state.languages = _.cloneDeep(languages)
    },
    [LIST_SMS_TEMPLATES_FAILED] (state, err) {
      console.error(err)
      state.loading = false
      state.error = err
    },

    [GET_TEMPLATE_STARTED] (state) {
      state.actionLoading = true
      state.actionError = undefined
    },
    [GET_TEMPLATE_COMPLETED] (state, template) {
      state.actionLoading = false
      state.template = template
    },
    [GET_TEMPLATE_FAILED] (state, err) {
      console.error(err)
      state.actionLoading = false
      state.actionError = err
    },

    [CREATE_TEMPLATE_STARTED] (state) {
      state.actionLoading = true
      state.actionError = undefined
    },
    [CREATE_TEMPLATE_COMPLETED] (state) {
      state.actionLoading = false
    },
    [CREATE_TEMPLATE_FAILED] (state, err) {
      console.error(err)
      state.actionLoading = false
      state.actionError = err
    },

    [RESTORE_TO_DEFAULT_TEMPLATE_STARTED] (state) {
      state.actionLoading = true
      state.actionError = undefined
    },
    [RESTORE_TO_DEFAULT_TEMPLATE_COMPLETED] (state) {
      state.actionLoading = false
    },
    [RESTORE_TO_DEFAULT_TEMPLATE_FAILED] (state, err) {
      console.error(err)
      state.actionLoading = false
      state.actionError = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async listEmailTemplates ({ commit, rootState: { client = undefined } }) {
      try {
        commit(LIST_EMAIL_TEMPLATES_STARTED)
        const { templates, languages } = await client.managementClient.listTemplates('email')
        commit(LIST_EMAIL_TEMPLATES_COMPLETED, { templates: templates.map(marshalTemplate), languages })
      } catch (err) {
        commit(LIST_EMAIL_TEMPLATES_FAILED, err)
      }
    },
    async listSMSTemplates ({ commit, rootState: { client = undefined } }) {
      try {
        commit(LIST_SMS_TEMPLATES_STARTED)
        const { templates, languages } = await client.managementClient.listTemplates('sms')
        commit(LIST_SMS_TEMPLATES_COMPLETED, { templates: templates.map(marshalTemplate), languages })
      } catch (err) {
        commit(LIST_SMS_TEMPLATES_FAILED, err)
      }
    },
    async getEmailTemplate ({ commit, rootState: { client = undefined } }, { language, name }) {
      try {
        commit(GET_TEMPLATE_STARTED)
        const { email_template: emailTemplate } = await client.managementClient.getTemplate('email', language, name)
        commit(GET_TEMPLATE_COMPLETED, {
          subject: emailTemplate.subject,
          textTemplate: emailTemplate.text_template,
          htmlTemplate: emailTemplate.html_template
        })
      } catch (err) {
        commit(GET_TEMPLATE_FAILED, err)
      }
    },
    async getSMSTemplate ({ commit, rootState: { client = undefined } }, { language, name }) {
      try {
        commit(GET_TEMPLATE_STARTED)
        const { sms_template: smsTemplate } = await client.managementClient.getTemplate('sms', language, name)
        commit(GET_TEMPLATE_COMPLETED, {
          template: smsTemplate.template
        })
      } catch (err) {
        commit(GET_TEMPLATE_FAILED, err)
      }
    },
    async createEmailTemplate ({ commit, rootState: { client = undefined } }, { language, name, subject, htmlTemplate, textTemplate }) {
      try {
        commit(CREATE_TEMPLATE_STARTED)
        await client.managementClient.createEmailTemplate(language, name, subject, htmlTemplate, textTemplate)
        commit(CREATE_TEMPLATE_COMPLETED)
      } catch (err) {
        commit(GET_TEMPLATE_FAILED, err)
      }
    },
    async createSMSTemplate ({ commit, rootState: { client = undefined } }, { language, name, template }) {
      try {
        commit(CREATE_TEMPLATE_STARTED)
        await client.managementClient.createSMSTemplate(language, name, template)
        commit(CREATE_TEMPLATE_COMPLETED)
      } catch (err) {
        commit(GET_TEMPLATE_FAILED, err)
      }
    },
    async restoreToDefaultEmailTemplate ({ commit, rootState: { client = undefined } }, { language, name }) {
      try {
        commit(RESTORE_TO_DEFAULT_TEMPLATE_STARTED)
        await client.managementClient.resetTemplate('email', language, name)
        commit(RESTORE_TO_DEFAULT_TEMPLATE_COMPLETED)
      } catch (err) {
        commit(RESTORE_TO_DEFAULT_TEMPLATE_FAILED, err)
      }
    },
    async restoreToDefaultSMSTemplate ({ commit, rootState: { client = undefined } }, { language, name }) {
      try {
        commit(RESTORE_TO_DEFAULT_TEMPLATE_STARTED)
        await client.managementClient.resetTemplate('sms', language, name)
        commit(RESTORE_TO_DEFAULT_TEMPLATE_COMPLETED)
      } catch (err) {
        commit(RESTORE_TO_DEFAULT_TEMPLATE_FAILED, err)
      }
    }
  }
}
